/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ProductFeedFacets HTTP resource (factory product). */
export class ProductFeedFacetsResource {
}

/** Angular DI token for the ProductFeedSearch HTTP resource (factory product). */
export class ProductFeedSearchResource {
}

/** Angular DI token for the ProductFeed HTTP resource (factory product). */
export class ProductFeedResource {
}

export function createProductFeedFacets(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return {
    getFacets(): Promise<any> {
      return send({
        method: 'GET',
        url: ApiConfig.obtain().getVersionedUri(['productfeed', 'facets']),
        params: {format: 'json', concise: true}
      });
    }
  };
}

export function createProductFeedSearch(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return {
    search(qStringParams: any): Promise<any> {
      return send({
        method: 'GET',
        url: ApiConfig.obtain().getVersionedUri(['productfeed']),
        params: _.assign({}, qStringParams, {format: 'json', concise: true})
      });
    }
  };
}

export function createProductFeedResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'productfeed/products',
    () => localUserProfile,
    'productFeed'
  );
}

export const productFeedFacetsProvider = {
  provide: ProductFeedFacetsResource,
  useFactory: createProductFeedFacets,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};

export const productFeedSearchProvider = {
  provide: ProductFeedSearchResource,
  useFactory: createProductFeedSearch,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};

export const productFeedResourceProvider = {
  provide: ProductFeedResource,
  useFactory: createProductFeedResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

